module.exports = __webpack_public_path__ + "static/media/toalhas.d9aefb95.jpg";